import styled from 'styled-components';

export const Dotarea = styled.span`
    position: relative;
    display: inline-block;
    height: calc(100vw*(18/375));
    width: calc(100vw*(4/375));
`;

export const Dot = styled.span`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: block;
    width: calc(100vw*(4/375));
    height: calc(100vw*(4/375));
    background: #4e4e4e;
    border-radius : 50%;

    &::before {
        content: '';
        position: absolute;
        top: calc(100vw*(-7/375));
        left: 0;
        display:block;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background: #4e4e4e;
        border-radius : 50%;
    }
    &::after {
        content: '';
        position: absolute;
        top: calc(100vw*(7/375));
        left: 0;
        display:block;
        width: calc(100vw*(4/375));
        height: calc(100vw*(4/375));
        background: #4e4e4e;
        border-radius : 50%;
    }
`